export enum ImageTypeEnum {
  'Одно изображение',
  'Базовое изображение и обрезка необходимой части',
  'Составное изображение',
  'Базовое изображение и его выделенная часть',
  'Анимация',
  'Масштабируемое изображение',
  'Масштабируемое изображение (плюс черный фон)',
  'Масштабируемая анимация',
  'Базовое изображение и его выделенная часть (плюс черный фон)',
}
